var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.491 2.491C2.93994 2.04206 3.66781 2.04206 4.11675 2.491L21.1871 19.5614C21.6361 20.0103 21.6361 20.7382 21.1871 21.1872C20.7382 21.6361 20.0103 21.6361 19.5614 21.1872L2.491 4.11675C2.04206 3.66781 2.04206 2.93993 2.491 2.491Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1871 2.49051C21.636 2.93945 21.636 3.66732 21.1871 4.11626L4.11674 21.1866C3.66781 21.6356 2.93993 21.6356 2.49099 21.1866C2.04206 20.7377 2.04206 20.0098 2.49099 19.5609L19.5613 2.49051C20.0103 2.04157 20.7382 2.04157 21.1871 2.49051Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.9a6c20d926a5376caa35292d0ddcfb18.svg";
export { ForwardRef as ReactComponent };